export default "__VITE_ASSET__Bo44Flx5__"